import { render, staticRenderFns } from "./RepeatOrders.vue?vue&type=template&id=8e17e5fe&scoped=true"
import script from "./RepeatOrders.vue?vue&type=script&lang=js"
export * from "./RepeatOrders.vue?vue&type=script&lang=js"
import style0 from "./RepeatOrders.vue?vue&type=style&index=0&id=8e17e5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e17e5fe",
  null
  
)

export default component.exports